import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

export interface HomologationMatrixStage {
  inHomologation: boolean;
}

export async function fetchHomologationMatrixStage(
  matrixId: number
): Promise<HomologationMatrixStage> {
  const response = await api.get<ApiResponse<HomologationMatrixStage>>(
    `/matrices/homologations/${matrixId}/stage`
  );

  if (!response.data.data) {
    throw new Error('Estágio do registro não encontrado.');
  }

  return response.data.data;
}
